import React from "react";

interface Props {
  className?: string;
}

const HEIGHT = 200;

export default function (props: Props) {
  return (
    <div
      style={{
        minHeight: HEIGHT,
        height: HEIGHT,
        maxHeight: HEIGHT
      }}
      className={props.className}
    />
  );
}
